<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="50%">
        <div class="contentDio" v-loading="detailLoading">
            <!-- 详细信息 -->
            <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
            <div class="detailMsg">
                <BaseList :baseMsg="baseMsg" :isMode="isMode" ref="BaseList" @saveDecFn="saveDecFn" />
                <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
                <changeIcon :isMode="isMode" @modeChange="modeChange" />
            </div>
            <Tabs :tabs="tabsArray" :activeCom.sync="TabsActive" @handleTabs="handleTabs" />
            <keep-alive>
                <component :is="TabsActive" v-bind="$attrs" />
            </keep-alive>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">
                {{ $t('buttonTitle.Close') }}
            </el-button>
        </div>
    </modal>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue';
import EscalRule from '@/pages/equipment/publicCom/EscalRule.vue';
import NetParam from '@/pages/equipment/publicCom/NetParam.vue';
import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Application from '@/pages/equipment/publicCom/Application.vue';
import Upload from '@/pages/equipment/publicCom/Upload.vue';

import BaseList from './component/BaseList.vue';

import { sensorUpdateSensor } from '@/api/modules/sensor.js';
export default {
    props: {
        title: {},
        isShowDetail: {},
        detailLoading: {},
        baseMsg: {
            type: Array
        },
        detailObj: {},
        sensorWay: {
            default: 'bind'
        }
    },
    watch: {
        detailObj(newVal) {
            this.isMode = false;
            this.Upload = {
                imageUrl: { ...newVal }.pictureBase64,
                // 图片后缀
                imageSuffix: { ...newVal }.pictureSuffix
            };
        }
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShowDetail;
            },
            set: function(val) {
                this.$emit('update:isShowDetail', val);
            }
        }
    },
    components: {
        Tabs,
        BaseList,
        Upload,
        changeIcon,
        Application,
        EscalRule,
        NetParam
    },
    data() {
        return {
            detailArray: [],

            isEdit: true,
            // 详细信息
            detailTbs: [
                {
                    name: 'Detail',
                    label: 'public.detail_info'
                }
            ],
            Dactive: 'Detail',
            // 图片
            Upload: {},
            // 设备tabs
            tabsArray: [
                {
                    name: 'Application',
                    label: 'public.attribute'
                },
                {
                    name: 'EscalRule',
                    label: 'public.escalation_rules'
                },
                {
                    name: 'NetParam',
                    label: 'public.net_param'
                }
            ],
            TabsActive: 'Application',
            // 模式切换
            isMode: false
        };
    },
    mounted() {},
    methods: {
        modeChange() {
            this.isMode = !this.isMode;
            this.$refs['BaseList'].areaValue = this.baseMsg[this.baseMsg.length - 1]['content'];
            this.$refs['BaseList'].nickname = this.baseMsg[this.baseMsg.length - 2]['content'];
        },
        saveDecFn(row) {
            const { imageSuffix, imageUrl } = this.$refs['upload'].newUpload;
            sensorUpdateSensor({
                id: this.detailObj['id'],
                nickname: row.nickname,
                description: row.areaValue,
                uploadFileBase64: imageUrl,
                uploadFileSuffix: imageSuffix
            }).then(async ({ state }) => {
                await this.$resultHandle(state);
                this.isEdit = !this.isEdit;
                this.$emit('changdetail', this.detailObj);
            });
        },
        isEditFn() {
            this.isEdit = !this.isEdit;
            this.$children.areaValue = this.baseMsg[this.baseMsg.length - 1]['content'];
            this.$children.nickname = this.baseMsg[this.baseMsg.length - 2]['content'];
        },
        cancelFn() {
            this.isEdit = !this.isEdit;
        },
        handleTabs(name) {
            this.TabsActive = name;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    min-width: 900px;
}
.contentDio {
    max-height: 700px;
    box-sizing: border-box;
    overflow: auto;

    .detailMsg {
        display: flex;
    }

    .msgContent {
        li {
            line-height: 30px;
        }
    }

    .m15 {
        margin: 15px 0;
    }

    ::v-deep .el-textarea__inner {
        border-radius: 2px;
        // margin-left: 5px;
    }
}
</style>
